import React from 'react';

interface ActivityBadgeProps {
  actionType: 'QUOTE_CREATED' | 'QUOTE_EDITED' | 'QUOTE_APPROVED' | 'QUOTE_REJECTED' | 'QUOTE_CANCELLED' | 'EMAIL_SENT';
}

export const ActivityBadge: React.FC<ActivityBadgeProps> = ({ actionType }) => {
  const getBadgeStyles = () => {
    switch (actionType) {
      case 'QUOTE_CREATED':
        return 'bg-blue-100 text-blue-800';
      case 'QUOTE_EDITED':
        return 'bg-yellow-100 text-yellow-800';
      case 'QUOTE_APPROVED':
        return 'bg-green-100 text-green-800';
      case 'QUOTE_REJECTED':
        return 'bg-red-100 text-red-800';
      case 'QUOTE_CANCELLED':
        return 'bg-gray-100 text-gray-800';
      case 'EMAIL_SENT':
        return 'bg-purple-100 text-purple-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };

  const getDisplayText = () => {
    return actionType.replace(/_/g, ' ').toLowerCase().replace(/\b\w/g, l => l.toUpperCase());
  };

  return (
    <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${getBadgeStyles()}`}>
      {getDisplayText()}
    </span>
  );
};